import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm }         from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

import { MessagesService }  from '../../app-lite/messages/messages.service';
import { MessengerService } from '../../app-lite/messages/messenger/messenger.service';

@Component({
  selector: 'wor-vehicle-visuals-email',
  template: `
    <div class="modal-header clearfix bg-info">
      <div class="pull-left">
        <h1>
          <i class="fa fa-envelope"></i>
          {{ 'VEHICLE_VISUALS_SPACE.EMAIL_ANIMATION' | translate }}
        </h1>
      </div>
    </div>
    <form class="form-horizontal" #emailForm="ngForm" novalidate
      (ngSubmit)="emailForm.valid && send()">
      <div class="modal-body">
        <div class="row">
          <fieldset class="col-md-8">
            <label id="email_label" class="control-label required"
              for="email"
              *ngIf="!(emailForm.controls.email?.dirty && emailForm.controls.email?.errors?.email)"
              [ngClass]="{ 'alert': emailForm.controls.email?.dirty && emailForm.controls.email?.errors?.required }"
              translate="GENERAL_SPACE.FIELD.EMAIL_ADDRESS">
            </label>
            <label class="alert"
              *ngIf="emailForm.controls.email?.dirty && emailForm.controls.email?.errors?.email"
              translate="GENERAL_SPACE.ERROR_MESSAGE.INVALID_EMAIL">
            </label>
            <div class="controls">
              <input id="email" class="form-control focused"
                type="email" name="email" maxlength="200"
                required
                [(ngModel)]="email.email_address">
            </div>
          </fieldset>
        </div>
        <div class="row">
          <hr>
        </div>
        <div class="row">
          <fieldset class="col-sm-12">
            <label id="subject_label" class="control-label"
              for="subject"
              translate="GENERAL_SPACE.MESSAGE.SUBJECT">
            </label>
            <div class="controls">
              <input id="subject" class="form-control focused"
                name="subject" type="text"
                maxlength="255"
                [(ngModel)]="email.subject">
            </div>
          </fieldset>
          <fieldset class="col-sm-12">
            <label id="message_label" class="control-label"
              for="message"
              translate="GENERAL_SPACE.MESSAGE.MESSAGE">
            </label>
            <wor-text-editor
              [(model)]="email.body">
            </wor-text-editor>
          </fieldset>
        </div>
        <div class="row">
          <hr>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="modal-footer">
        <div class="pull-right">
          <button class="btn btn-success"
            type="submit"
            *ngIf="!sending"
            translate="GENERAL_SPACE.BUTTON.SEND">
          </button>
          <span *ngIf="sending">
            <i class="vertical-align-middle fa fa-spinner fa-spin fa-2x"></i>
          </span>
        </div>
        <button class="btn btn-cancel pull-left"
          type="button"
          [disabled]="sending"
          (click)="modal.dismiss()"
          translate="GENERAL_SPACE.BUTTON.CANCEL">
        </button>
      </div>
    </form>
  `
})
export class VehicleVisualsEmailComponent implements OnInit {
  @Input() emailAddress: string;
  @Input() url         : string;
  @Input() visual      : any;

  email: any = {};
  sending = false;

  constructor (
    public  modal             : NgbActiveModal,
    private messagesService   : MessagesService,
    private messengerService  : MessengerService,
    private translateService  : TranslateService
  ) {}

  ngOnInit (): void {
    this.email = {
      email_address: this.emailAddress,
      body         : this.translateService.instant('JS_SPACE.VEHICLE_VISUALS.EMAIL_BODY', {
        desc : this.visual.description || this.visual.description_en_AU,
        line : '<br>',
        link : `<a href="${this.url}" target="_blank">here</a>`,
        title: this.visual.title || this.visual.en_AU
      }),
      subject: this.translateService.instant('JS_SPACE.VEHICLE_VISUALS.EMAIL_SUBJECT', {
        title: this.visual.title || this.visual.en_AU
      })
    };
  }

  send (): void {
    this.sending = true;

    this.messengerService.sendEmail(this.email)
      .then(() => {
        this.modal.close();
      })
      .catch(( err ) => {
        this.messagesService.error(err);
      })
      .finally(() => {
        this.sending = false;
      });
  }
}
